import { render } from "./DetalharCategoriaPlano.vue?vue&type=template&id=2735db05&scoped=true"
import script from "./DetalharCategoriaPlano.vue?vue&type=script&lang=js"
export * from "./DetalharCategoriaPlano.vue?vue&type=script&lang=js"

import "./DetalharCategoriaPlano.vue?vue&type=style&index=0&id=2735db05&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2735db05"]])

export default __exports__